// extracted by mini-css-extract-plugin
module.exports = {"text":"CallMessageContent__text___vRFi4","prompt":"CallMessageContent__prompt___RqCr8"};